import { useEffect, useState } from "react";
import useUser from "hooks/useUser";
import Select from 'react-select';
import DayJS from 'react-dayjs';
import setDate from "date-fns/set";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import StyledCard from 'components/StyledCard';
import useAuth from "../../hooks/useAuth";
import useAPI from "../../hooks/useAPI";
import PageLayout from "components/PageLayout";
import BackButton from "components/BackButton";
import useStyles from './styles';
import { getPersonName } from 'utils/helper';
import { toast } from 'react-toastify';
import { useHistory } from "react-router-dom";

const Swap = () => {
  const { user } = useUser();
  const history = useHistory();
  const [appointments, setAppointments] = useState([[], []]);
  const [users, setUsers] = useState([])
  const [technician, setTechnician] = useState([]);
  const api = useAPI();
  const styles = useStyles();
  
  useEffect(() => {
    if (user.role !== "tech.admin") history.push("/app")
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  useEffect(() => {
    api
    .get('/users')
    .then(res => {
      setUsers(
        res.data.users
        .filter(user => user.role.includes('tech.'))
        .map(user => ({ label: getPersonName(user), value: user._id }))
        )
    })
    .catch(err => console.log(err))
    // eslint-disable-next-line
  }, [])

  const getAppointmentByTechnician = (technicianId, index) => {
    api
      .get(`/technicians/${technicianId}/appointments`, {
        params: {
          start: setDate(new Date(), {
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0,
          })
        },
      })
      .then(async (res) => {
        const _appointments = res.data.appointments.filter((appt) => !appt.completed && appt.technician._id === technicianId);
        if (index === 0)
          setAppointments([_appointments, appointments[1]]);
        else
          setAppointments([appointments[0], _appointments]);
      })
      .catch((err) => {
        console.log(err);
      })

  }

  const onChangeFirstTechnician = (value) => {
    setTechnician([value, technician[1]]);
    if (value && value.value) getAppointmentByTechnician(value.value, 0);
  }

  const onChangeSecondTechnician = (value) => {
    setTechnician([technician[0], value]);
    if (value && value.value) getAppointmentByTechnician(value.value, 1);
  }

  const swapJobs = () => {
    api.post("/appointments/swap", {
      firstTechnicianId: technician[0].value,
      firstApptIds: appointments[0].map(appt => appt._id),
      secondTechnicianId: technician[1].value,
      secondApptIds: appointments[1].map(appt => appt._id)
    }).then((res) => {
      if (res.status === 200) {
        toast.success('Successfully swapped the appointments.')
        setAppointments([appointments[1], appointments[0]])
      }
    });
  }

  return (
    <PageLayout title="Swap Job">
      <Container maxWidth="md">
        <Box display="flex" alignItems="center" justifyContent="space-between" mt={3}>
          <Box>
            <Typography className={styles.heading}>Swap Schedule</Typography>
            <Box my={1}>
              <Button color="primary" variant="contained" size="md" className={styles.swapButton} onClick={swapJobs} disabled={!technician[0] || !technician[1]}>Swap</Button>
            </Box>
            <BackButton url='/' />
          </Box>
          <Box >
            <Box display="flex" alignItems="center" justifyContent="space-between" my={1} width={350}>
              <Typography>First Tech:</Typography>
              <Box width={200}>
                <Select
                  placeholder="Technician"
                  options={users}
                  width={250}
                  value={technician[0]}
                  onChange={ onChangeFirstTechnician }
                  menuPortalTarget={document.body} 
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  />
              </Box>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" my={1} width={350}>
              <Typography>Second Tech:</Typography>
              <Box width={200}>
                <Select
                  placeholder="Technician"
                  options={users}
                  width={250}
                  value={technician[1]}
                  onChange={ onChangeSecondTechnician }
                  menuPortalTarget={document.body} 
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box display="flex" mt={5}>
          <Box flex="1" mr={2}>
            <Typography variant="h3" className={styles.technicianLabel}>{ technician[0] ? `${technician[0]?.label}'s schedule` : '' }</Typography>
            {
              appointments[0] && 
              <StyledCard variant="outlined">
              {
                appointments[0].map((appt) => (
                  <Box key={appt._id} className={styles.box}>
                    <Box flex={1}>
                      <Typography variant="h6" className={styles.subheading}><DayJS format="hh:mm a">{ appt.start }</DayJS> ~ <DayJS format="hh:mm a">{ appt.end }</DayJS></Typography>
                    </Box>
                    <Box flex={1}>
                      <Typography className={styles.paragraph}>{`${appt.customer.firstName} ${appt.customer.middleName} ${appt.customer.lastName}`}</Typography>
                      <Typography className={styles.paragraph}>{`${appt.customer.streetNumber} ${appt.customer.streetName}`} {appt.customer.unit ? `UNIT ${appt.customer.unit}` : ''}</Typography>
                      <Typography className={styles.paragraph}>{`${appt.customer.city}, ${appt.customer.primaryPhone}`}</Typography>
                      <Typography className={styles.paragraph}>Enrollment #: { appt.customer.enrollment?.enrollmentNumber }</Typography>
                    </Box>
                  </Box>
              ))}
              </StyledCard>
            }
          </Box>
          <Box flex="1" ml={2}>
            <Typography variant="h3" className={styles.technicianLabel}>{ technician[1] ? `${technician[1]?.label}'s schedule` : '' }</Typography>
            {
              appointments[1] && 
              <StyledCard variant="outlined">
              {
                appointments[1].map((appt) => (
                <Box key={appt._id} className={styles.box}>
                  <Box flex={1}>
                    <Typography variant="h6" className={styles.subheading}><DayJS format="hh:mm a">{ appt.start }</DayJS> ~ <DayJS format="hh:mm a">{ appt.end }</DayJS></Typography>
                  </Box>
                  <Box flex={1}>
                    <Typography className={styles.paragraph}>{`${appt.customer.firstName} ${appt.customer.middleName ? appt.customer.middleName : ""} ${appt.customer.lastName}`}</Typography>
                    <Typography className={styles.paragraph}>{`${appt.customer.streetNumber} ${appt.customer.streetName}`} {appt.customer.unit ? `UNIT ${appt.customer.unit}` : ''}</Typography>
                    <Typography className={styles.paragraph}>{`${appt.customer.city}, ${appt.customer.primaryPhone}`}</Typography>
                    <Typography className={styles.paragraph}>Enrollment #: { appt.customer.enrollment?.enrollmentNumber }</Typography>
                  </Box>
                </Box>
                ))
              }
              </StyledCard>
            }
          </Box>
        </Box>
      </Container>
    </PageLayout>
  );
};

const Page = () => {
  const { PrivateContent } = useAuth();
  return (
    <PrivateContent title="Swap Jobs">
      <Swap />
    </PrivateContent>
  );
};

export default Page;
